import { useEffect } from "react";

export default function useLegacyContactScripts(enabled = true) {
  useEffect(() => {
    if (!enabled) return;

    const iframeLinkSelector = 'link[data-legacy-iframe-css="true"]';
    if (!document.querySelector(iframeLinkSelector)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "/css/iframe.css";
      link.setAttribute("data-legacy-iframe-css", "true");
      document.head.appendChild(link);
    }

    const contactSrc = "/js/contact.js";
    const contactScriptSelector = `script[data-legacy-contact-src="${contactSrc}"]`;
    if (!document.querySelector(contactScriptSelector)) {
      const script = document.createElement("script");
      script.src = contactSrc;
      script.async = false;
      script.setAttribute("data-legacy-contact-src", contactSrc);
      document.body.appendChild(script);

      // No need to await; we only need the binding to happen after mount.
      script.onload = () => {};
      script.onerror = () => {};
    }

    // Keep it loaded across SPA navigations.
    return () => {};
  }, [enabled]);
}

